/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Use_4_ValueInputs */

const en_svc_research_use_4_value = /** @type {(inputs: Svc_Research_Use_4_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articles are researched and every claim is checked against its source before a person reviews it.`)
};

const lv_svc_research_use_4_value = /** @type {(inputs: Svc_Research_Use_4_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raksti tiek izpētīti, un katrs apgalvojums pārbaudīts pret avotu, pirms to pārskata cilvēks.`)
};

/**
* | output |
* | --- |
* | "Articles are researched and every claim is checked against its source before a person reviews it." |
*
* @param {Svc_Research_Use_4_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_use_4_value = /** @type {((inputs?: Svc_Research_Use_4_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Use_4_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_use_4_value(inputs)
	return en_svc_research_use_4_value(inputs)
});